import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Typography } from '@material-ui/core';

const CardDescription = ({ classes, description, userBrand }) => {
  return (
    <div className={cx(classes.cardActionDescription)}>
      <Typography component="h2" className={classes.cardDescription}>
        {description}
      </Typography>
      <Typography variant="body2" color="textSecondary" component="p">
        {userBrand === 'NM' ? 'Neimanmarcus.com' : 'Bergdorfgoodman.com'}
      </Typography>
    </div>
  );
};

CardDescription.propTypes = {
  classes: PropTypes.shape({}),
  description: PropTypes.string,
  userBrand: PropTypes.oneOf(['NM', 'BG']),
};

CardDescription.defaultProps = {
  classes: {},
  description: '',
  userBrand: 'NM',
};

export default CardDescription;
